import { ImageComponent, toPlaceholderImage } from '@frontend/internal-assets';
import type { ImageAssetProps } from '@frontend/internal-assets';
import optimizedImage from './image-assets/call-intel-call-intel-trial-promo-banner.webp';

const thumbHashString = '/PeBA4AedvGXZp7vnPpX2jg4iodwqAg=';
const placeholderImage = toPlaceholderImage(thumbHashString);

const calculatedAspectRatio = 1.7423014586709886;
const originalWidth = 1075;

const CallIntelcallinteltrialpromobanner = ({
  aspectRatio = calculatedAspectRatio,
  width = originalWidth,
  ...rest
}: ImageAssetProps) => (
  <ImageComponent
    aspectRatio={aspectRatio}
    width={width}
    src={optimizedImage}
    placeholderSrc={placeholderImage}
    {...rest}
  />
);

export default CallIntelcallinteltrialpromobanner;
